import { FC } from "react";
import chain from "../../common/images/chain.png";
import { t } from "../../common/miscellaneous/t";
import { useIsNavigateErrorPage } from "../../common/hooks/useIsNavigateErrorPage";
import { SampleRouteButtons } from "./SampleRouteButtons";

export const SampleRoute: FC = () => {
  useIsNavigateErrorPage();

  return (
    <div className="tw-p-8">
      <div className="tw-flex  tw-justify-center tw-items-center tw-gap-6">
        <img
          src={chain}
          alt="not found"
          className="tw-pr-6 tw-border-r tw-border-gray-200"
        />
        <div className="tw-font-bold">
          <div className="tw-text-2xl">{t("mk-hc-sample-route-info")}</div>
          <div className="tw-my-3">{t("mk-hc-page-unavailable")}</div>
          <SampleRouteButtons />
        </div>
      </div>
    </div>
  );
};
